// extracted by mini-css-extract-plugin
export default {"input":"WidgetEmail_input__H9Iqq"};